import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Card, Button, Typography } from 'antd';
import { AntdTag } from '../Tag/Tag';

import { colors } from '../../styles/colors';

const { Title } = Typography;

const StyledTitle = styled.div`
  .subheading {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: ${colors['neutral']['9']};
  }

  .additional-text {
    color: ${colors['neutral']['8']};
    white-space: pre-wrap;
  }
`;

const StyledCardItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SummaryCard = ({ heading, subheading, additionalText, status, tag, children }) => {
  const CardTitle = () => (
    <StyledTitle>
      <Title level={5}>{heading}</Title>
      <div className="subheading">
        {subheading}
        {additionalText && <span className="additional-text">{additionalText}</span>}
      </div>
    </StyledTitle>
  );

  const extra = tag ? tag : status && <AntdTag status={status} />;

  return (
    <Card title={<CardTitle />} extra={extra}>
      {children}
    </Card>
  );
};

const Item = ({ label, buttonText, onClick }) => (
  <StyledCardItem>
    <span>{label}</span>
    <span>
      {(buttonText !== undefined || buttonText !== null) && (
        <Button type="link" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </span>
  </StyledCardItem>
);

SummaryCard.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string,
  additionalText: PropTypes.string,
  status: PropTypes.string,
  tag: PropTypes.element,
  children: PropTypes.node,
};

Item.propTypes = {
  label: PropTypes.string.isRequired,
};

SummaryCard.Item = Item;
export { SummaryCard };
